import { Component, OnDestroy, OnInit } from '@angular/core';
import { Video } from 'src/app/models/videoModel';
import { DomSanitizer } from '@angular/platform-browser';
import { EventsService } from 'src/app/core/services/events/events.service';
import { take } from 'rxjs/operators';
import { CalendarEvent } from 'angular-calendar';
import { MatDialog } from '@angular/material/dialog';
import { EventDetailsModalComponent } from 'src/app/shared/dialogs/event-details-modal/event-details-modal.component';
import {AboutcedlabService} from '../../core/services/about-cedlab/aboutcedlab.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: []
})
export class HomeComponent implements OnInit, OnDestroy {

  videoList: Video[];
  activeVideo: Video;
  calendarReady: boolean;
  events: CalendarEvent<{ description: string }>[];
  calendarLoadingFailed = 'Si è verificato un errore nel caricamento. Riprova più tardi';

  getAboutCedlabSubscription: Subscription;

  constructor(
    private sanitizer: DomSanitizer,
    public eventsService: EventsService,
    public eventDetailsDialog: MatDialog,
    public aboutCedlabService: AboutcedlabService,
  ) {
    this.events = [];

    this.videoList = [
      {
        id: 'NXCQFfXjFiU',
        thumbnailImg: 'https://i.ytimg.com/vi/NXCQFfXjFiU/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLC7p54I0FsVgCSNWD13PVuIwqQBzg',
      },
      {
        id: 'R0xlXRrvqWQ',
        thumbnailImg: 'https://i.ytimg.com/vi/R0xlXRrvqWQ/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBh8CxGnKOELCE6HCKEctOGQ-5wSg',
      },
      {
        id: 'Tmm3a6F6Nww',
        thumbnailImg: 'https://i.ytimg.com/vi/Tmm3a6F6Nww/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLA7XxiI1l4fzrr4NFNYmMhDD3BUlg',
      },
      {
        id: '9kcmd-5ItHw',
        thumbnailImg: 'https://i.ytimg.com/vi/9kcmd-5ItHw/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLAnMNIrNC2wyw4p8z1VwlK-rbG8hw',
      },
    ];
  }

  ngOnInit(): void {
    this.getAboutCedlabSubscription = this.getAboutCedlab();
    this.eventsService.getEvents()
      .pipe(take(1))
      .subscribe(
        () => {
          this.events = [...this.eventsService.events];
          this.calendarReady = true;
        },
        error => {
          this.calendarReady = false;
          console.log(error);
        }
      );

  }

  openEventDetails(eventId: string | number) {
    this.eventDetailsDialog.open(EventDetailsModalComponent, {
      data: this.eventsService.searchEventById(Number(eventId))
    });
  }


  loadVideo(v: Video) {
    this.activeVideo = v;
  }

  getVideoUrl(v: Video) {
    return v && this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${v.id}`);
  }

  closePlayer() {
    this.activeVideo = null;
  }

  getAboutCedlab() {
    return this.aboutCedlabService.getAboutCedlab().subscribe(res => {

    },
      error => {
      console.log('Get About Cedlab failed');
      });
  }

  ngOnDestroy(): void {
    this.getAboutCedlabSubscription?.unsubscribe();
  }

}
